export default __webpack_public_path__ + "locales/it/SMTPSettings.json?hash=407c1e1caf1feecad864a0447720cd30";